import { useTranslate } from '@tolgee/react';
import { LogItemProps } from '../LogItemLayout';

export const useDetail = (data: LogItemProps['data']) => {
  const { t } = useTranslate();
  const { operateType, changeField, changeDetail } = data;

  if (operateType !== 'UPDATE_ROUND') return null;

  if (changeField === 'ROUND_EXECUTE_TIME') {
    return {
      // @ts-ignore
      before: changeDetail?.before,
      // @ts-ignore
      after: changeDetail?.after,
    };
  }

  if (changeField === 'ROUND_EXECUTE_TIME_UNIT' && changeDetail?.before && changeDetail?.after) {
    const timeMapper = {
      MINUTES: t('marketing.分钟'),
      HOURS: t('marketing.小时'),
    };
    return {
      // @ts-ignore
      before: timeMapper[changeDetail.before],
      // @ts-ignore
      after: timeMapper[changeDetail.after],
    };
  }

  return null;
};
